import Icon from '../components/Icon';
import AnimatedSection from '../components/AnimatedSection';

// --- Projects Section ---
const Projects = () => (
    <AnimatedSection id="projects" className="py-24">
        <h2 className="text-3xl font-bold text-white text-center mb-12">Featured Project</h2>
        <div className="max-w-4xl mx-auto">
            <div className="project-card bg-slate-800/50 rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-cyan-500/20 hover:scale-[1.02] backdrop-blur-sm border border-slate-700/50">
                <div className="p-8">
                    <h3 className="text-2xl font-bold text-white">[CleanArch/MVI Template] SakeTour 🍶</h3>
                    <p className="mt-4 text-slate-400 leading-relaxed">
                        SakeTour is more than an app—it's a comprehensive template for modern Android development. Built to showcase best practices in Jetpack Compose, MVI, and Clean Architecture, it serves as a learning resource for developers and a testament to my commitment to high-quality, maintainable code.
                    </p>
                     <div className="mt-6">
                        <a href="https://github.com/algeronimo92/Template-Android-MVI-CleanArchitecure-SakeTour" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold text-cyan-400 hover:text-cyan-300 transition-colors">
                            View on GitHub <Icon name="arrowUpRight" className="w-4 h-4" />
                        </a>
                    </div>
                    <div className="mt-8 rounded-lg aspect-video overflow-hidden shadow-lg bg-slate-900">
                        <img 
                            src="/images/sake3.png" 
                            alt="SakeTour App Preview" 
                            className="w-full h-full object-cover"
                            onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/1280x720/1E293B/334155?text=SakeTour+App'; }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </AnimatedSection>
);


export default Projects;